import mixpanel from "mixpanel-browser"
import { isAnalyticsSuppressed } from "./analyticsSuppression"
import { IS_PRODUCTION_ENV } from "./environment"

/** Sends an event to Mixpanel + GA4. Drops silently when suppressed. */
export function trackEvent(
  name: string,
  payload: Record<string, unknown> = {}
) {
  if (!IS_PRODUCTION_ENV) return
  if (isAnalyticsSuppressed()) return

  try {
    mixpanel.track(name, payload)
  } catch {
    // Mixpanel not initialized yet, skip
  }
  window.gtag?.("event", name, payload)
}
